import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Jumps the window to the top on every route change (navigation, back, forward).
 * Runs before paint (useLayoutEffect) so the new page appears already at top.
 * We explicitly request an "instant" scroll and bypass TypeScript's narrower
 * ScrollBehavior type using a type assertion.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    // Disable the browser's native scroll restoration so back/forward
    // navigations don't restore the previous scroll position.
    useLayoutEffect(() => {
        if ('scrollRestoration' in window.history) {
            const previous = window.history.scrollRestoration;
            window.history.scrollRestoration = 'manual';
            return () => {
                window.history.scrollRestoration = previous;
            };
        }
        return undefined;
    }, []);

    useLayoutEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
